import type { IconData } from '@stacksjs/iconify-core'

export const angleRightB: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.172 18.657a1 1 0 0 1-.707-1.707l4.95-4.95l-4.95-4.95a1 1 0 0 1 1.414-1.414l5.656 5.657a1 1 0 0 1 0 1.414L9.88 18.364a1 1 0 0 1-.707.293Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default angleRightB
